﻿import React, { useState, useEffect, Fragment } from 'react';
import { Feather } from '../../../helpers/Feather';
import { CartProductProps } from './Interfaces';
import { ProductImage, CartProductBuyer, Price } from './Components';

export function CartProduct(props: CartProductProps) {
    function qtyChanged(qty: number) {
        props.itemCountChanged(props.product.id, props.variant.id, qty);
    }

    const ordered = props.cart.products.find(x => x.productVariantId === props.variant.id)?.quantity ?? 0;

    return (
        <div className={ordered > 0 ? "cart-product d-flex mb-3" : "cart-product d-flex mb-3 qty-0"}>
            <ProductImage image={props.product.image} />

            <div className="p-info flex-column flex-sm-row ml-3 pt-1 pb-1 pr-3">
                <div>
                    <h5 className="p-title">{props.product.name}</h5>
                    {props.variant.name ? (<span className="p-subtitle text-muted">{props.variant.name}</span>) : null}                
                    
                </div>
                <div className="flex-grow-1">
                </div>
                <div className="p-buy-qty">
                    <Price product={props.product} variant={props.variant} priceOnly={true} />

                    <div className="p-buy ml-1 mr-3">
                        <Feather icon="x" size={16} /> <CartProductBuyer qty={ordered} setQty={qtyChanged} canEdit={props.cart.status === 'Active'} />
                    </div>

                    <Price product={props.product} variant={props.variant} qty={ordered} priceOnly={true} />
                </div>
            </div>
        </div>
    );
}